import { apiFetch, getAccessToken } from '../../../lib/api';

/**
 * Fetches list of notifications.
 * @param {Object} params - Query params (skip, limit, unread_only, category, priority, sort, start_date, end_date)
 * @param {string} [token] - Access token
 */
export const listNotifications = async (params = {}, token = getAccessToken()) => {
    const searchParams = new URLSearchParams();

    // Default pagination params
    searchParams.append('skip', params.skip !== undefined ? params.skip : 0);
    searchParams.append('limit', params.limit !== undefined ? params.limit : 50);

    if (params.unread_only !== undefined && params.unread_only !== null) {
        searchParams.append('unread_only', params.unread_only);
    }
    if (params.category && params.category !== 'all') {
        searchParams.append('category', params.category);
    }
    if (params.priority && params.priority !== 'all') {
        searchParams.append('priority', params.priority);
    }
    if (params.sort) {
        searchParams.append('sort', params.sort);
    }
    if (params.start_date) {
        searchParams.append('start_date', params.start_date);
    }
    if (params.end_date) {
        searchParams.append('end_date', params.end_date);
    }

    const endpoint = `/api/v1/notifications?${searchParams.toString()}`;
    return apiFetch(endpoint, {
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Fetches the count of unread notifications.
 * @param {string} [token] - Access token
 */
export const getUnreadCount = async (token = getAccessToken()) => {
    const endpoint = '/api/v1/notifications/unread-count';
    return apiFetch(endpoint, {
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Marks a specific notification as read.
 * @param {string} recipientId - UUID of the recipient notification
 * @param {string} [token] - Access token
 */
export const markAsRead = async (recipientId, token = getAccessToken()) => {
    const endpoint = `/api/v1/notifications/${recipientId}/read`;
    return apiFetch(endpoint, {
        method: 'PATCH',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Marks all notifications as read.
 * @param {string} [token] - Access token
 */
export const markAllAsRead = async (token = getAccessToken()) => {
    const endpoint = '/api/v1/notifications/read-all';
    return apiFetch(endpoint, {
        method: 'PATCH',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Deletes a notification.
 * @param {string} recipientId - UUID of the recipient notification
 * @param {string} [token] - Access token
 */
export const deleteNotification = async (recipientId, token = getAccessToken()) => {
    const endpoint = `/api/v1/notifications/${recipientId}`;
    return apiFetch(endpoint, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Sends a notification.
 * @param {Object} data - Notification body data
 * @param {string} [token] - Access token
 */
export const sendNotification = async (data, token = getAccessToken()) => {
    const endpoint = '/api/v1/notifications/send';
    return apiFetch(endpoint, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: JSON.stringify(data),
    });
};

/**
 * Bulk sends notifications.
 * @param {Object} data - Bulk notification body data
 * @param {string} [token] - Access token
 */
export const bulkSendNotifications = async (data, token = getAccessToken()) => {
    const endpoint = '/api/v1/notifications/bulk-send';
    return apiFetch(endpoint, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: JSON.stringify(data),
    });
};
